export default "__VITE_ASSET__8f41b741__"